import cx from 'clsx'
import React from 'react'
import { CSSProperties, MouseEventHandler } from 'react'

import cn from './styles.module.scss'

import { Icon } from '../../icons'

export const IconInputField = ({
  Icon,
  isActive,
}: {
  Icon: any
  isActive: boolean
}) => {
  if (!Icon) {
    return null
  }

  return (
    <div className={cn.icon}>
      <Icon color={isActive ? 'color' : 'grey'} width={18} height={18} />
    </div>
  )
}

export const IconDownArrowInputField = ({
  isActive,
  style = {},
}: {
  isActive: boolean
  style?: React.CSSProperties
}) => {
  return (
    <div className={cn.arrow} style={style}>
      <Icon
        name='arrow-down-filled'
        color={isActive ? 'var(--clr-svg-gradient)' : 'var(--grey-600)'}
        size={12}
      />
    </div>
  )
}

export const InputInputField = ({
  isActive,
  label = '',
  placeholder = '',
  field,
  style = {},
}: {
  isActive: boolean
  label?: string
  placeholder?: string
  field: any
  style?: React.CSSProperties
}) => {
  if (field) {
    return (
      <input
        placeholder={placeholder}
        value={field.value || ''}
        onChange={field.onChange}
        onBlur={field.onBlur}
        className={cn.input}
      />
    )
  }

  return (
    <div
      className={cx(
        cn.label,
        { [cn.labelPlaceholder]: !isActive },
        { [cn.labelActive]: isActive },
      )}
      style={style}
    >
      <span>{isActive ? label : placeholder}</span>
    </div>
  )
}

interface IInputField {
  onClick?: MouseEventHandler
  styleField?: CSSProperties
  Icon?: any
  label?: string
  placeholder?: string
  disabled?: boolean
  fullWidth?: boolean
  isActive?: boolean
  field?: any
  selected?: number
  hideArrow?: boolean
}

export const InputField = ({
  onClick,
  styleField = {},
  Icon,
  label,
  placeholder,
  disabled = false,
  fullWidth = false,
  isActive = false,
  field,
  selected,
  hideArrow = false,
}: IInputField) => {
  return (
    <div
      className={cx(cn.formControl, {
        [cn.active]: isActive,
        [cn.disabled]: disabled,
        [cn.fullWidth]: fullWidth,
      })}
      style={styleField}
      onClick={(e) => onClick && onClick(e)}
    >
      {Icon && <IconInputField Icon={Icon} isActive={isActive} />}

      <InputInputField
        isActive={isActive}
        label={label}
        placeholder={placeholder}
        field={field}
      />

      {!field && !hideArrow && (
        <>
          {selected ? (
            <div className={cn.counter}>{selected}</div>
          ) : (
            <IconDownArrowInputField isActive={isActive} />
          )}
        </>
      )}
    </div>
  )
}
